
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pt-br/ia/rastreamento-de-cargas",
      function () {
        return require("private-next-pages/pt-br/ia/rastreamento-de-cargas/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pt-br/ia/rastreamento-de-cargas"])
      });
    }
  